import React from 'react'
import { Link } from 'react-router-dom'
import Footer from './Footer'
import { useAuth0 } from '@auth0/auth0-react'
import { LayoutDashboard } from 'lucide-react'

/**
 * Public layout component for legal and marketing pages
 * Includes header, footer, and traditional website structure
 */
const HomeLayout = ({ children }) => {
  const { isAuthenticated, user, logout, isLoading } = useAuth0()

  return (
    <div className="min-h-screen bg-gray-50 grid grid-rows-[auto_1fr_auto]">
      {/* Header - always visible */}
      <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center space-x-2 text-xl font-bold text-gray-900">
              <img 
                src="https://startup-tnt-documents.tor1.digitaloceanspaces.com/public/startuptnt-icon.svg" 
                alt="Startup TNT Icon" 
                className="h-6 w-6"
              />
              <span>Angel Vault</span>
            </Link>
          </div>

          {/* User Menu / Auth */}
          {isAuthenticated ? (
            <div className="flex items-center space-x-4">
              {/* Dashboard link with icon */}
              <Link 
                to="/dashboard"
                className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
              >
                <LayoutDashboard className="h-4 w-4" />
                <span>Dashboard</span>
              </Link>
            </div>
          ) : (
            <div className="flex items-center space-x-4">
                <Link 
                to="/login"
                className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
              >
                Sign In
              </Link>
            </div>
          )}
          </div>
      </div>
    </header>
      
        
      {/* Main content area */}
      <main className="min-w-0">
        {children}
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  )
}

export default HomeLayout